import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routeConfig, getFlatRoutes, VIEW_MODE_MAP } from '@/config/routeConfig';
import RouteGuard from '@/components/RouteGuard/RouteGuard';
import Profile from '@/containers/facility/Profile/Profile';

const SignIn = lazy(() => import('@/containers/LoginPages/SignIn/SignIn'));
const SwitchView = lazy(() => import('@/containers/LoginPages/SwitchView/SwitchView'));
const ResetPassword = lazy(() => import('@/containers/LoginPages/ResetPassword/ResetPassword'));
const SignUp = lazy(() => import('@/containers/LoginPages/SignUp/SignUp'));
const Help = lazy(() => import('@/containers/Help/help'));
const LayoutWrapper = lazy(() => import('@/layout'));
const NotFound = lazy(() => import('@/containers/LoginPages/404/NotFound'));
const Forbidden = lazy(() => import('@/containers/LoginPages/403/Forbidden'));

// 生成受保护的路由
const generateProtectedRoutes = () => {
  const allRoutes = [];
  
  // 遍历所有视图类型
  Object.keys(routeConfig).forEach(viewType => {
    const flatRoutes = getFlatRoutes(viewType);
    
    flatRoutes.forEach(route => {
      allRoutes.push({
        path: route.path,
        element: (
          <RouteGuard 
            requiredPermission={route.code} 
            viewType={viewType}
          >
            {route.component}
          </RouteGuard>
        ),
        handle: {
          tab: route.title
        }
      });
    });
  });
  
  return allRoutes;
};

// 默认重定向组件
const DefaultRedirect = () => {
  const viewMode = useSelector(state => state.App.viewMode);
  const currentViewType = VIEW_MODE_MAP[viewMode];
  
  // 根据当前视图模式重定向到对应的默认页面
  switch(currentViewType) {
    case 'facility':
      return <Navigate to="/facility/dashboard" replace />;
    case 'admin':
      return <Navigate to="/admin/user-management" replace />;
    case 'portfolio':
      return <Navigate to="/portfolio/dashboard" replace />;
    default:
      return <Navigate to="/facility/dashboard" replace />;
  }
};

export const routes = [
  {
    path: '/login',
    element: <SignIn />,
  },
  {
    path: '/switch-view',
    element: <SwitchView />,
  },
  {
    path: '/password/reset/confirm/:uid/',
    element: <ResetPassword />,
  },
  {
    path: '/signup',
    element: <SignUp />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '/403',
    element: <Forbidden />,
  },
  {
    path: '/',
    element: <LayoutWrapper />,
    children: [
      {
        index: true,
        element: <DefaultRedirect />,
      },
      {
        path: '/help',
        element: <Help />,
        name: 'contact',
        handle: {
          tab: 'Contact us'
        }
      },
      {
        path: '/common/profile',
        element: <Profile />,
        name: 'profile',
        handle: {
          tab: 'Profile'
        }
      },
      ...generateProtectedRoutes()
    ]
  },
  // 通配符路由，匹配所有未定义的路径
  {
    path: '*',
    element: <NotFound />,
  }
]